import { combineReducers } from 'redux';
import { reducers as machete } from 'src/machete-redux';
import { connectRouter } from 'connected-react-router';

import designPro from 'src/redux/reducers';

const createRootReducer = (history) => {
  return combineReducers({
    designPro,
    machete,
    router: connectRouter(history),
  });
};

export default createRootReducer;
